/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import { Sophistication } from '../../classes/sophistication.js';
import componentClassNames from './index.module.scss';
var sophistication = new Sophistication({
  /**
   * @description Input JSS styles.
   * @param {*} params - Component props.
   * @returns {Object<string,*>} Style.
   */
  input: function input() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = params.customColors || {},
        _ref$focusColor = _ref.focusColor,
        focusColor = _ref$focusColor === void 0 ? '#e88b0e' : _ref$focusColor;

    return _defineProperty({}, "&:focus + .".concat(componentClassNames.label, "::before"), {
      borderColor: getStatusColor(params) || focusColor
    });
  },

  /**
   * @description Label JSS styles.
   * @param {*} params - Component props.
   * @returns {Object<string,*>} Style.
   */
  label: function label() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref3 = params.customColors || {},
        _ref3$borderColor = _ref3.borderColor,
        borderColor = _ref3$borderColor === void 0 ? 'rgba(0,0,0,0.7)' : _ref3$borderColor,
        _ref3$backgroundColor = _ref3.backgroundColor,
        backgroundColor = _ref3$backgroundColor === void 0 ? 'rgba(0,0,0,0.1)' : _ref3$backgroundColor,
        _ref3$fillColor = _ref3.fillColor,
        fillColor = _ref3$fillColor === void 0 ? '#666666' : _ref3$fillColor;

    var statusColor = getStatusColor(params);
    return {
      '&::before': {
        backgroundColor: backgroundColor,
        borderColor: statusColor || borderColor
      },
      '&::after': {
        backgroundColor: params.status === 'warning' ? statusColor : fillColor
      }
    };
  }
});
/**
 * @description Returns status corresponding color.
 * @param {*} params - Component props.
 * @returns {(string|null)} Color or null.
 */

function getStatusColor(params) {
  var _ref4 = params.customColors || {},
      _ref4$validColor = _ref4.validColor,
      validColor = _ref4$validColor === void 0 ? '#94ff36' : _ref4$validColor,
      _ref4$invalidColor = _ref4.invalidColor,
      invalidColor = _ref4$invalidColor === void 0 ? '#e83b35' : _ref4$invalidColor,
      _ref4$warningColor = _ref4.warningColor,
      warningColor = _ref4$warningColor === void 0 ? '#e8e639' : _ref4$warningColor,
      _ref4$highlightColor = _ref4.highlightColor,
      highlightColor = _ref4$highlightColor === void 0 ? '#666666' : _ref4$highlightColor;

  switch (params.status) {
    case 'valid':
      return validColor;

    case 'invalid':
      return invalidColor;

    case 'warning':
      return warningColor;

    case 'highlight':
      return highlightColor;

    default:
      return null;
  }
}

export { sophistication };